class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      await this.request('add', data);
      const response = await this.request('get');
      this.cart = response;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      console.log(data);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data, updateType=null) {
    try {
      const responseData = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      if(updateType != null) {
        if(updateType == 'plus') {
          this.dispatchEvent("item_added", true);
        } else {
          this.dispatchEvent("item_removed", true);
        }
      }
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {
      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      const cart_tabs = document.querySelectorAll('.cart-tabs .cart-tab');
      const cart_content = document.querySelector('.basket-cart');
      const saved_content = document.querySelector('.saved-cart');

      cart_content.style.display = 'flex';
      saved_content.style.display = 'none';

      cart_tabs[0].classList.add('active');
      cart_tabs[1].classList.remove('active');

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector('.side-cart-recommended').classList.add('open');
        this.dispatchEvent("side_cart_opened", false);
      }
      const for_you_open_els = document.querySelectorAll('[open-for-you]');
  
      if (for_you_open_els) {
        for_you_open_els.forEach(for_you_open_el => {
          
          for_you_open_el.addEventListener('click', (e)=> {
            e.preventDefault();
            cart_tabs.forEach(tab => {
              tab.classList.remove('active');
            })
            document.querySelector('.cart-tab[data-tab="for-you"]').classList.add('active');
            document.querySelector('.for-you').classList.add('active');
            document.querySelector('.for-you').style.display = 'flex';
            document.querySelector('.saved-cart').style.display = 'none';
            document.querySelector('.cart-content').style.display = 'none';
            var swiper = new window.swiper('.for-you-swiper', {
              slidesPerView: 1.4,
              spaceBetween: 20,
            });
          });
          
        });
      }

      const back_to_basket_btn = document.querySelector('.cart-content .back');

      if (back_to_basket_btn) {
        back_to_basket_btn.addEventListener('click', (e)=> {
          e.preventDefault();
          cart_tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          document.querySelector('.cart-tab[data-tab="basket-cart"]').classList.add('active');
          document.querySelector('.cart-content').style.display = 'flex';
          document.querySelector('.saved-cart').style.display = 'none';
          document.querySelector('.for-you').style.display = 'none';
        })
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector('.side-cart-recommended').classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  updateCartProgress() {
    const side_cart_inner = document.querySelector("#cart-drawer-container .inner");
    const cart_progress_container = document.querySelector('.cart-progress-container');
    const status_text = cart_progress_container.querySelector('.status');
    const currency_symbol = status_text.getAttribute('data-currency-symbol');

    const delivery_dot = cart_progress_container.querySelector('.progress-dot.delivery');
    // const gift_dot = cart_progress_container.querySelector('.progress-dot.gift');
    const delivery_icon = cart_progress_container.querySelector('.icon-marker.delivery');
    // const gift_icon = cart_progress_container.querySelector('.icon-marker.gift');

    const total_price = side_cart_inner.querySelector('.sub-total').getAttribute('data-sub-total') / 100;
    const delivery_threshold = cart_progress_container.getAttribute('data-delivery-threshold');
    // const gift_threshold = cart_progress_container.getAttribute('data-gift-threshold');
    // const max = Math.max( gift_threshold, delivery_threshold );
    const max = delivery_threshold;

    // const gift_percent = (gift_threshold / max) * 100;
    const delivery_percent = (delivery_threshold / max) * 100;
    
    let progress = ( total_price / max ) * 100;
    if (progress > 100) progress = 100;

    //console.log('🚀 gift percent: ', gift_percent, ' delivery_percent: ', delivery_percent, 'progress: ', progress);

    let status_msg;
    if ( progress >= 100 ) {
      status_msg = `Congratulations! You are eligible for Free Delivery`

      /*
    } else if ( progress > delivery_percent ) {
      status_msg = `£${ (gift_threshold - total_price).toFixed(2) } from your FREE Gift`;
    */
    } else if ( progress < delivery_percent ) {
      status_msg = `${currency_symbol}${ (delivery_threshold - total_price).toFixed(2) } from your FREE Delivery`;
      
    }
    status_text.innerHTML = status_msg;

    /*
    // Check Gift Progress
    if ( progress >= gift_percent ) {
      gift_dot.classList.add('active');
      gift_icon.classList.add('active');
    }
    else {
      gift_dot.classList.remove('active');
      gift_icon.classList.remove('active');
    }
    */

    // Check Delivery Progress
    if ( progress >= delivery_percent ) {
      delivery_dot.classList.add('active');
      delivery_icon.classList.add('active');
    } else {
      delivery_dot.classList.remove('active');
      delivery_icon.classList.remove('active');
    }

    cart_progress_container.style.setProperty('--progress', `${ progress }%` );
  }

  async reRenderSideCart(successCallback = null) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=mm-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["mm-side-cart"];


      const side_cart_inner = document.querySelector("#cart-drawer-container .inner");
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
        this.updateCartProgress();
        // const free_gift_items = side_cart_inner.querySelectorAll(".item[data-has-free-gift]");
        // const are_free_gifts = side_cart_inner.querySelector(".item[data-is-free-gift]");

        let item_count = parseInt(side_cart_inner.querySelector('.cart').getAttribute('data-items-count'));
        let cart_count_el = document.querySelector('.cart-counter');

        if (item_count == 0) {
          cart_count_el.style.opacity = "0";
        } else if (item_count == 1) {
            cart_count_el.style.opacity = "1";
            cart_count_el.innerHTML = `${item_count}`;
        } else {
            cart_count_el.style.opacity = "1";
            cart_count_el.innerHTML = `${item_count}`;
        }
        
        const cart_tabs = document.querySelectorAll('.cart-tabs .cart-tab');
        cart_tabs.forEach(tab => {
          tab.classList.remove('active');
        })
        document.querySelector('.cart-tab[data-tab="basket-cart"]').classList.add('active');
        document.querySelector('.cart-content').style.display = 'flex';
        document.querySelector('.saved-cart').style.display = 'none';
        document.querySelector('.for-you').style.display = 'none';
        
        // this.gift_with_purchase(free_gift_items, are_free_gifts);

        let first_cart_item = side_cart_inner.querySelector('.item');
        if (first_cart_item) {
          first_cart_item = first_cart_item.dataset.productId;
        }

        if (window.innerWidth > 767.98) {
            
            new window.swiper(".cart-recommendations-slider", {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: ".swiper-button-next.cart-rec",
                prevEl: ".swiper-button-prev.cart-rec",
              },
              lazy: {
                enabled: true,
                checkInView: false,
                loadOnTransitionStart: true,
                loadPrevNext: true,
                loadPrevNextAmount: 1
              },
              breakpoints: {
                1134: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                }
              },
              pagination: {
                el: ".swiper-pagination.cart-swiper-pagination",
                clickable: true
              },
            });
        }
        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

reRenderCart() {
    fetch(window.Shopify.routes.root + "cart?sections=mm-cart")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        // console.log('TEST', data);
        // Extract the "v2-cart" field from the JSON data
        let html = data["mm-cart"];
        let cart_inner = document.querySelector("#cart-container");
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(html);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }

  gift_with_purchase(items,gifts) {
    const no_thanks_btn = document.querySelector('.no-thanks');

    // const setCookie = (name, value) => {
    //   var expires = new Date();
    //   expires.setTime(expires.getTime() + (24 * 60 * 60 * 1000));
    //   document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    // }
    
    // // Usage:
    // var cookieName = 'decline_gift';
    // var cookieValue = 'decline_gift';
    // var hoursToExpire = 24;
    
    // setCookie(cookieName, cookieValue);

    if (!gifts) {
      gifts_length = 0;
    } else {
      gifts_length = gifts.length;
    }
    if (items.length) {
      if (items.length > gifts_length) {
        setTimeout(() => {
          const cart_contents = document.querySelectorAll('.cart-content');
          cart_contents.forEach(el => {
            el.style.display = 'none';
          });
          var swiper = new window.swiper('.free-gift-swiper', {
            slidesPerView: 2.2,
            spaceBetween: 20,
            breakpoints: {
              376: {
                slidesPerView: 1.4,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              }
            },
          });
          document.querySelector('.free-gifts-cart').style.display = 'flex';
        }, 2000);
      }
    }
  }
}

// export default new CartQf();
window.CartQf = CartQf;